import { render, staticRenderFns } from "./TicketsTemplate.vue?vue&type=template&id=641a897a&scoped=true&"
import script from "./TicketsTemplate.vue?vue&type=script&lang=js&"
export * from "./TicketsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TicketsTemplate.vue?vue&type=style&index=0&id=641a897a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a897a",
  null
  
)

export default component.exports